module.exports = __webpack_public_path__ + "static/media/lyge.b6f2eaf1.m4a";